/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {WelcomePageComponent} from './welcome-page.component';

@NgModule({
    declarations: [WelcomePageComponent]
})
export class WelcomePageModule {
}
